<template>
    <div>
        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent novalidate @input="productAcivateUpdateFlag('salesChannels')">
                        <div v-if="isReadOnly" class="color-1 my-4 p-4">
                            This product is currently inactive. To make changes, please activate it first.
                        </div>

                        <div class="px-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="panel shaded">

                                        <h5>Sales channel configurations</h5>

                                        <div class="fs-small dark mt-2 mb-3">
                                            Select the sales channel were this product will be available for sale.<br>
                                            Set default commission for this product, this will be used if the seller has no other commission specified for the product.
                                        </div>


                                        <table style="width:100%" cellspacing="0" cellpadding="0" border="0">

                                            <tr class="fs-small dark">
                                                <th rowspan="2" class="niceColumn colHead">
                                                    Open
                                                    <div class="mt-1 d-flex flex-row justify-content-center">
                                                        <span class="hoverLink" :class="{ notAllowed: isReadOnly, disabled: isReadOnly }" @click="!isReadOnly && selectAll(true)">
                                                            All
                                                        </span>
                                                        
                                                        <span class="mx-1">/</span>
                        
                                                        <span class="hoverLink" :class="{ notAllowed: isReadOnly, disabled: isReadOnly }" @click="!isReadOnly && selectAll(false)">
                                                        None
                                                        </span>

                                                    </div>
                                                </th>
                                                <th rowspan="2" class="pl-3">Channel</th>
                                                <th rowspan="2" class="niceColumn colHead">Channel Price Increase</th>
                                                <th>&nbsp;</th>
                                                <th colspan="2" class="niceColumn colHead">Commissions</th>
                                                <th>&nbsp;</th>
                                                <th rowspan="2" class="niceColumn colHead">Manual Confirmation</th>
                                            </tr>

                                            <tr class="fs-small dark">
                                                <th>&nbsp;</th>

                                                <th class="niceColumn colHead">Tickets</th>
                                                <th class="niceColumn colHead">Extras</th>
                                            </tr>

                                            <tr :class="[!isReadOnly ? 'hoverOk' : '',salesChannel.isActive ? 'active' : 'notActive', salesChannel.channelType == 50 ? 'alignTop' : '', 'pointer', { notAllowed: isReadOnly }]" v-for="(salesChannel, index) in sortedSalesChannels" :key="salesChannel.id">
                                                <!-- Allowed to sell -->
                                                <td class="niceColumn colContent text-center">
                                                    <checkbox class="my-2" v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)"  :disabled="isReadOnly" :class="{ 'notAllowed': isReadOnly }"></checkbox>
                                                </td>

                                                <td style="width:100%;" :class="{'alignTop': salesChannel.channelType == 50}">
                                                    <div class="d-flex flex-column">
                                                        <div class="d-flex flex-row align-items-center pl-3">
                                                            <!-- <checkbox v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)"> -->
                                                                {{salesChannel.channelName}}
                                                            <!-- </checkbox> -->

                                                            <div class="ml-4" v-if="salesChannel.channelType == 50">
                                                                <v-select :options="agentsChannelOptions" :disabled="isReadOnly || !salesChannel.isActive" v-model="selectedAgentsChannelOptions" @input="agentsChannelOptionsChanged($event, salesChannel)"></v-select>
                                                            </div>
                                                        </div>

                                                        <div class="px-3 py-2 bg-lightest d-flex flex-column my-2" v-if="salesChannel.channelType == 50 && form.salesPermissionsAgentsCustom">
                                                            <agent-white-list
                                                                class="mt-2"
                                                                style="width: 50%; min-width: 250px;"
                                                                :allowedList="form.salesPermissionsAgentsList"
                                                                :blockedList="form.salesBlockedAgentList"
                                                                :startAllSelected="customAgentListSelectAll"
                                                                @input="agentListChanged">
                                                            </agent-white-list>
                                                        </div>
                                                    </div>
                                                </td>

                                                <!-- Price Multiplier -->
                                                <td class="niceColumn colContent text-center">
                                                    <div class="d-flex">
                                                        <input class="glued-right" style="width: 3rem;" type="number" :value="getMultiplier(salesChannel.channelId)" @input="event => setMultiplier(salesChannel.channelId, event.target.value)" :disabled="isReadOnly">
                                                        <div class="glued-left" :class="{ 'disabled-channel-price': isReadOnly }">%</div>
                                                    </div>
                                                </td>
                                                <!-- Empty Column for spacing -->
                                                <td>
                                                    &nbsp;
                                                </td>
                                                <!-- Ticket -->
                                                <td class="niceColumn colContent">
                                                    <div class="d-flex">
                                                        <input type="number" class="glued-right mr-0 pr-0 vselect-compact" :disabled="isReadOnly || !salesChannel.isActive" v-model="salesChannel.productAmountValue">
                                                        <v-select class="glued-left vselect-compact" v-model="salesChannel.productAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged(salesChannel, index, 'productAmountType')" :disabled="isReadOnly || !salesChannel.isActive"></v-select>
                                                    </div>
                                                </td>

                                                <!-- Extras -->
                                                <td class="niceColumn colContent">
                                                    <div class="d-flex">
                                                        <input type="number" class="glued-right mr-0 pr-0 vselect-compact" :disabled="isReadOnly || !salesChannel.isActive" v-model="salesChannel.componentAmountValue">
                                                        <v-select class="glued-left vselect-compact" v-model="salesChannel.componentAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged(salesChannel, index, 'componentAmountType')" :disabled="isReadOnly || !salesChannel.isActive"></v-select>
                                                    </div>
                                                </td>

                                                <!-- Empty Column for spacing -->
                                                <td>
                                                    &nbsp;
                                                </td>

                                                <!-- Manual Confirmation -->
                                                <td class="niceColumn colContent text-center">
                                                    <template v-if="canThisChannelHaveManualConfirmation(salesChannel)">
                                                        <checkbox class="my-2" v-model="salesChannel.isManualConfirmation" :disabled="isReadOnly || !salesChannel.isActive"></checkbox>
                                                    </template>
                                                    <template v-else>
                                                        <i class="fas fa-info-circle fs-large dark mr-1" v-tooltip="'This sales channel cannot have manual confirmation'"></i>
                                                    </template>
                                                </td>


                                            </tr>

                                        </table>


                                    </div>

                                </div>


                                <!-- OFF - Manual Confirmation Global -->
                                <div v-if="false" class="col-sm-4">
                                    <div class="panel shaded">
                                        <h5>Booking confirmation</h5>

                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <label class="full">
                                                    <span class="d-flex">
                                                        Manual confirmation
                                                    <toggle-button
                                                        class="ml-auto"
                                                        v-model="form.hasManualConfirmation"
                                                        :labels="{checked: 'YES', unchecked: 'NO'}"/>
                                                    </span>

                                                    <div class="fs-smaller mt-2 normal">
                                                        If this option is
                                                        <span class="underlined">enabled</span>
                                                        , every booking coming from customers and
                                                        agents is not confirmed until you manually accept it.
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import AgentWhiteList from './components/AgentWhiteList'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 4,
                form: {},
                agentsChannelOptions: [
                    {
                        label: 'All Agents',
                        value: false
                    },
                    {
                        label: 'Agent Selection',
                        value: true
                    }
                ],
                selectedAgentsChannelOptions: {
                    label: 'All Agents',
                    value: false
                },
                originalSalesChannels: null
            }
        },
        validations: {
            salesChannelsAgent: {
                validateAgentChannel() {
                    return this.validateSalesChannelAgents
                }
            }
        },
        watch: {
            stepNavigation(val) {
                this.$emit('stepNavigationChanged', val);
            }
        },
        created: function() {
            this.form = structuredClone(this.getClonedItem);

            if(this.form.salesPermissionsAgentsList == undefined){
                this.$set(this.form, 'salesPermissionsAgentsList', [])
            }
            if(this.form.salesBlockedAgentList == undefined){
                this.$set(this.form, 'salesBlockedAgentList', [])
            }

            //add sales channel helpers
            this.addSalesChannelHelpers()
            
            if(!this.form.productChannelSettings){ 
                this.form.productChannelSettings = [] // in new products
            }

            //starts with custom agent selection collapsed
            this.setCorrectCustomAgentDropdown()


            //saves a copy of the saleschannels, this is used to check on %/€ change if they are diferent to trigger update flags
            this.originalSalesChannels = structuredClone(this.form.channelCommissions)
        },
        mounted() {
            this.$emit('stepNavigationChanged', this.stepNavigation);
            // If "agent selection" is selected, the drop should be open, else, should be closed
            this.selectedAgentsChannelOptions.value == true ? this.form.salesPermissionsAgentsCustom = true : this.form.salesPermissionsAgentsCustom = false
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'getPercentageOrCurrency',
                'getChannelsNotAllowedToHaveManualConfirmation'
            ]),
            isReadOnly() {
                return this.form && this.form.active === false;
            },
            stepNavigation() {
                return {
                    canProceed: !this.$v.$invalid,
                    canSave: !this.$v.$invalid,
                    canGoBack: true,
                };
            },
            sortedSalesChannels: function(){
                let arrayToSort = this.form.channelCommissions;

                return arrayToSort.sort(function(channelA, channelB) {
                    if(channelA.name > channelB.name){
                        return 1;
                    } else if (channelA.name < channelB.name) {
                        return -1;
                    } else {
                        return 0;
                    }
                })


            },
            customAgentListSelectAll: function(){
                if(this.getSelectedItem == null){
                    //is creting new product
                    return true
                } else {
                    return null
                }
            },
            validateSalesChannelAgents: function () {
                if (!Array.isArray(this.form.channelCommissions)) return true;
                let agentsChannel = this.form.channelCommissions.filter(channel => {
                    return channel.channelType == 50
                })

                if (agentsChannel.length > 0) {
                    agentsChannel = agentsChannel[0]
                } else {
                    return false
                }

                if(agentsChannel.isActive && this.form.salesPermissionsAgentsCustom == true && this.form.salesPermissionsAgentsList.length == 0){
                    return false
                } else {
                    return true
                }
            },
        },
        methods: {
            getMultiplier(id) {
            let percent = 0;
            let productItemSettings = this.form.productChannelSettings.find((e) => e.channelId == id);

                if (productItemSettings) {
                    if (productItemSettings.priceMultiplier === 0) return 0;

                    // We're reciving priceMultiplier values as 1,30 instead 30%, so we have to format the value before showing
                    percent = ((productItemSettings.priceMultiplier * 100) - 100).toFixed(2);

                    if (percent.endsWith('.00')) {
                        percent = percent.split('.')[0];
                    }
                } else {
                    let priceMultiplierForChannel = {
                        "id": 0,
                        "priceMultiplier": 1,
                        "channelId": id
                    };

                    this.form.productChannelSettings.push(priceMultiplierForChannel);
                }

                return percent;
            },
            setMultiplier(id,updatedValue) {
                let productItemSettings = this.form.productChannelSettings.find((e) => e.channelId == id);
                
                if (updatedValue < -99 || updatedValue > 100) {
                    this.$toasted.error('Value must be between -99 and 100');
                }

                // Reconfig the value of multiplier to send in the payload
                productItemSettings.priceMultiplier = Number(((updatedValue / 100) + 1).toFixed(2));
            },
            agentListChanged: function(agentList) {
                this.$set(
                    this.form,
                    'salesPermissionsAgentsList',
                    agentList.filter(agent => {
                        return agent.selected == true
                    })
                )

                this.$set(
                    this.form,
                    'salesBlockedAgentList',
                    agentList.filter(agent => {
                        return !agent.selected || agent.selected == false
                    })
                )

                this.productAcivateUpdateFlag('salesChannels');
            },
            agentsChannelOptionsChanged: function($event, salesChannel) {


                // salesChannel.isActive = true
                this.form.salesPermissionsAgentsCustom = $event.value
                if($event.value == false){
                    this.form.salesPermissionsAgentsList = []
                    this.form.salesBlockedAgentList = []
                }

                // update flags
                this.productAcivateUpdateFlag('salesChannels');
            },
            salesChannelStateChanged: function (channel) {
                if(channel.channelType == 50 && channel.isActive == false){
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[0]
                }

                // If "agent selection" is selected, the drop should be open, else, should be closed
                this.selectedAgentsChannelOptions.value == true ? this.form.salesPermissionsAgentsCustom = true : this.form.salesPermissionsAgentsCustom = false
            },
            addSalesChannelHelpers: function () {
                //sort channelType
                this.form.channelCommissions = this.form.channelCommissions.sort(function(salesChannelA, salesChannelB) {
                    if(salesChannelA.channelType > salesChannelB.channelType){
                        return -1;
                    } else{
                        return 1;
                    }
                })
                //sort type
                this.form.channelCommissions = this.form.channelCommissions.sort(function(salesChannelA, salesChannelB) {
                    if(salesChannelA.channelType == 0 || salesChannelA.channelType == 9999){
                        return -1;
                    } else{
                        return 1;
                    }
                })

                this.form.channelCommissions.map(salesChannel => {
                    // sets Type helper
                    salesChannel.productAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.productAmountType == percentageOrCurrency.id
                    })[0]
                    salesChannel.componentAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.componentAmountType == percentageOrCurrency.id
                    })[0]
                    salesChannel.transportAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.transportAmountType == percentageOrCurrency.id
                    })[0]

                    if(salesChannel.channelName){
                        salesChannel.name = salesChannel.channelName
                    }
                })
            },
            setCorrectCustomAgentDropdown: function (){
                if(this.form.salesPermissionsAgentsList && this.form.salesPermissionsAgentsList.length > 0){
                    this.$set(this.form, 'customAgentSelectionVisible', true)
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[1]
                } else {
                    this.$set(this.form, 'customAgentSelectionVisible', false)
                }

            },
            commissionTypeChanged: function(salesChannel, index, target){
                let helper = target+'_helper_selected'
                let setTo = target
                salesChannel[setTo] = salesChannel[helper].id

                // check if was changed
                let originalVal = this.originalSalesChannels[index][helper].id
                let newVal = salesChannel[setTo]
                if(originalVal != newVal){
                    this.productAcivateUpdateFlag('salesChannels')
                }
            },
            canThisChannelHaveManualConfirmation: function (channel) {
                return !this.getChannelsNotAllowedToHaveManualConfirmation.some(id => id == channel.channelType)
            },
            getStepState: function() {
                return { invalid: this.$v.$invalid, form: this.form };
            },
            readyToSave: function() {
                let somePriceGreaterThan100 = this.form.productChannelSettings.some((e) => 
                e.priceMultiplier > 2 || e.priceMultiplier < 0.01)
                if(somePriceGreaterThan100){
                    this.$emit('readyToSave', { invalid: true, form: this.form});
                } else {
                    this.$emit('readyToSave', { invalid: false, form: this.form});

                }
            },
            selectAll(select) {
                this.form.channelCommissions.forEach(channel => {
                    channel.isActive = select;
                });
                this.productAcivateUpdateFlag('salesChannels');
            },
        },
        components: {
            vSelect: extendedVSelect,
            AgentWhiteList
        }
    }
</script>

<style lang="scss" scooped>
    @import '../../../assets/scss/_variables.scss';
    @import '../../../assets/scss/_utility.scss';

    .channelOptions label:not(.vue-js-switch, .originalLabel){
        color: $darker !important;
        @extend .fs-normal;
    }

    table{
        width: 100%;

        tr{

            .niceColumn{
                background-color: $lighter;
                &.colHead{
                    text-align: center;
                    padding: 0.3125rem 0.5rem;
                }

                &.colContent{
                    padding: 0.125rem 0.25rem;
                }
            }

        // &.active{
            //   &.colContent{
            //   }
            //} 

            &.notActive{
                .colContent{
                    background-color: $red-pale !important;
                }
            }

            &.hoverOk:hover{
                background-color: $lighter;

                .niceColumn{
                    background-color: $medium;
                }
            }

            th{
                @extend .fs-normal;
            }

            td{
                // vertical-align: top;
                vertical-align: middle;


            }
            &.alignTop{
                td{
                    vertical-align: top;
                }
            }
        }
    }
        .hoverLink.disabled, .hoverLink.notAllowed {
            text-decoration: none;  
        }
        .disabled-channel-price {
            color: #8ca0b3;
        }
        .vselect-compact {
            width: 2.8rem;
        }
</style>



// WEBPACK FOOTER //
// ProductChannels.vue?448deea6